import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-center items-center h-full bg-zinc-800" }
const _hoisted_2 = { class: "flex flex-col justify-center items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: "/images/logo-tsc.svg",
  class: "w-64",
  alt: "ГЦТИ"
}, null, -1)
const _hoisted_4 = ["href"]

import { computed, ref } from 'vue';
import { setTitle } from '../title';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const redirectTo = computed(() => {
  return location.protocol + '//' + location.host + '/bitrix-login';
});

setTitle('Авторизация');


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "flex-none mb-8"
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createElementVNode("a", {
        href: 'https://crm.globaldrive.ru/my.globaldrive.ru.php?return=' + _unref(redirectTo),
        class: "block flex-none py-3 px-6 text-lg font-bold text-zinc-100 bg-cyan-600 hover:bg-cyan-500 rounded"
      }, " Войти с помощью Битрикс24 ", 8, _hoisted_4)
    ])
  ]))
}
}

})